var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "btn-group mb-1" },
        [
          _vm.canGeneral
            ? _c(
                "TabButton",
                {
                  attrs: { tab: "tab1" },
                  model: {
                    value: _vm.tab,
                    callback: function($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("settings.tabs.tab1")))]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.canNotification
            ? _c(
                "TabButton",
                {
                  attrs: { tab: "tabNotifications" },
                  model: {
                    value: _vm.tab,
                    callback: function($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("settings.tabs.tabNotifications")))]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.canNotification
            ? _c(
                "TabButton",
                {
                  attrs: { tab: "reports" },
                  model: {
                    value: _vm.tab,
                    callback: function($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("settings.tabs.reports")))]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.canGeneral
            ? _c(
                "TabButton",
                {
                  attrs: { tab: "kiosk" },
                  model: {
                    value: _vm.tab,
                    callback: function($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("settings.tabs.kiosk")))]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.canLocalization
            ? _c(
                "TabButton",
                {
                  attrs: { tab: "tabLocalization" },
                  model: {
                    value: _vm.tab,
                    callback: function($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("settings.tabs.tabLocalization")))]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.canGeneral
        ? _c("Tab1", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.tab === "tab1",
                expression: "tab === 'tab1'"
              }
            ]
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.canNotification
        ? _c("Reports", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.tab === "reports",
                expression: "tab === 'reports'"
              }
            ]
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.canNotification
        ? _c("TabNotifications", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.tab === "tabNotifications",
                expression: "tab === 'tabNotifications'"
              }
            ]
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.canGeneral
        ? _c("Kiosk", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.tab === "kiosk",
                expression: "tab === 'kiosk'"
              }
            ]
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.canLocalization
        ? _c("TabLocalization", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.tab === "tabLocalization",
                expression: "tab === 'tabLocalization'"
              }
            ]
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }